// ct-navigation-filter.service.ts
import { Injectable, inject } from '@angular/core';
import { SelectedWorkspaceService } from '@cloud-twin-v2/cloud-twin-shared/selected-workspace.service';
import { BaseLink } from '@common-modules/navigation/models/base-link';
import { MenuLink } from '@common-modules/navigation/models/menu-link';
import { ModuleLink } from '@common-modules/navigation/models/module-link';

import { Observable, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CtNavKeys } from '../ct-nav-keys';

@Injectable({
  providedIn: 'root',
})
export class CtNavigationFilterService {
  private readonly _selectedWorkspaceService = inject(SelectedWorkspaceService);

  filterNavigationModules(modules$: Observable<Array<BaseLink>>): Observable<Array<BaseLink>> {
    return combineLatest([
      modules$,
      this._selectedWorkspaceService.selectedWorkspace$.pipe(startWith(null)),
    ]).pipe(
      map(([modules, workspace]) => {
        if (!workspace) {
          return this.filterModules(modules);
        }
        return modules;
      })
    );
  }

  private filterModules(modules: Array<BaseLink>): Array<BaseLink> {
    return modules
      .map((module) => {
        if (module instanceof MenuLink) {
          const key = module.key;
          if (key === CtNavKeys.Map || key === CtNavKeys.Measurements) {
            return null;
          }
          return module;
        }

        if (module instanceof ModuleLink) {
          const moduleLink = { ...module } as ModuleLink;
          moduleLink.menuLinks = moduleLink.menuLinks.filter((menuLink) => {
            const key = (menuLink as any).key;
            return key !== CtNavKeys.Map && key !== CtNavKeys.Measurements;
          });
          return moduleLink.menuLinks.length > 0 ? moduleLink : null;
        }

        return module;
      })
      .filter((module) => module !== null);
  }
}
